/**
 * Pack GI Presenze - registrazione lato frontend.
 *
 * NB: la mappa route→topic autoritativa arriva dal backend
 * (/api/guide/topics). Questa mappa locale e' un fallback per l'apertura
 * offline o pre-fetch.
 */
import { registerPack } from "@/foundation/guide/registry";

export const APP_KEY = "presenze";

const ROUTE_TOPICS_FALLBACK = {
  "/": "cruscotto",
  "/aziende": "azienda",
  "/dipendenti": "dipendenti",
  "/profili-orari": "profili",
  "/presenze": "presenze",
  "/report": "report",
  "/calendario-ferie": "calendario",
  "/assenze-permessi": "assenze",
  "/richieste-ferie": "assenze",
  "/import-excel": "importazioni",
  "/import-tabulato": "importazioni",
  "/import-cartellino": "importazioni",
  "/impostazioni": "impostazioni",
  "/guidata": "guidata",
  "/riconciliazione": "riconciliazione",
  "/mio-profilo": "dipendenti",
};

registerPack({
  appKey: APP_KEY,
  appLabel: "GI Presenze",
  routeTopics: ROUTE_TOPICS_FALLBACK,
});
